<template>
  <div v-if="showModal" class="side__modal opened">
    <div class="side__modal__content">
      <div class="modal__top">
        <div class="modal__header">
          <h3 class="modal__title">{{ $lang.app.ADD_EXECUTORS }}</h3>
          <span class="modal__close" @click="closeModal">
          <svg viewBox="0 0 20 20" width="20" height="20"><use xlink:href="@/assets/v2/img/sprite.svg#modal__close"></use></svg></span>
        </div>
      </div>

      <Form class="modal__footer"
            @submit="submit">

        <div v-if="userResolutionRole !== 'ROLE_HEAD_OF_DEPARTMENT'" class="input__group input__add__info">
          <label for="state-input" class="label">{{ $lang.app.SUBDIVISION }}</label>
          <div class="select__wrapper">
            <Field name="state" v-slot="{ field, errorMessage }">
              <Multiselect
                  id="state-input"
                  :class="{'select--fail': errorMessage }"
                  v-bind="field"
                  v-model="state"
                  :options="helper.stateOptions"
                  :placeholder="$lang.app.SELECT_FROM_OPTIONS"
                  :searchable="true"
                  :noOptionsText="$lang.app.LIST_EMPTY"
                  :noResultsText="$lang.app.NOT_FOUND"
                  :can-clear="false">
              </Multiselect>
              <span v-if="errorMessage" class="input__fail">{{ errorMessage }}</span>
            </Field>
          </div>
        </div>

        <div v-if="userResolutionRole !== 'ROLE_HEAD_OF_DEPARTMENT'" class="input__group input__add__info">
          <label for="department-input" class="label">{{ $lang.app.DEPARTMENT }}</label>
          <div class="select__wrapper">
            <Field name="department" v-slot="{ field, errorMessage }">
              <Multiselect
                  id="department-input"
                  :class="{'select--fail': errorMessage }"
                  v-bind="field"
                  v-model="department"
                  :options="helper.departmentOptions"
                  :placeholder="$lang.app.SELECT_FROM_OPTIONS"
                  :searchable="true"
                  :noOptionsText="$lang.app.LIST_EMPTY"
                  :noResultsText="$lang.app.NOT_FOUND"
                  :can-clear="false">
              </Multiselect>
              <span v-if="errorMessage" class="input__fail">{{ errorMessage }}</span>
            </Field>
          </div>
        </div>

        <ExecutorsMultiselect
            :value="form.employees"
            @update="form.employees = $event"
            :options="helper.employeeOptions"/>

        <div class="between__buttons">
          <button type="button" class="button button__modal__close button--cancel"
                  @click="closeModal">{{ $lang.app.CANCEL }}</button>
          <button type="submit" class="relative button button__modal__close"
                  :disabled="submitting">
            {{ $lang.app.ADD }}
            <div v-if="submitting" class="loading-blue text-white absolute z-10 w-full rounded-lg h-full top-0 left-0 flex items-center justify-center">
              <div class="block animate-spin">
                <RefreshIcon class="w-6 h-6 mirror-y"/>
              </div>
            </div>
          </button>
        </div>
      </Form>
    </div>
  </div>
</template>
<script>
import {Field, Form} from 'vee-validate';

import stateApi from "../../../../../api/employee/state";
import employeeApi from "../../../../../api/employee/employee";

import ExecutorsMultiselect from "../../inputs/ExecutorsMultiselect";
import departmentApi from "../../../../../api/employee/department";
import resolutionApi from "../../../../../api/employee/resolution";
import executorTypes from "../../../../../helpers/constants/executorTypes";

export default {
  props: {
    resolution: Object,
    userResolutionRole: String
  },
  components: {
    Field,
    Form,
    ExecutorsMultiselect
  },
  data() {
    return {
      showModal: false,

      submitting: false,

      state: null,
      department: null,
      form: {
        employees: [],
      },
      helper: {
        stateOptions: [],
        departmentOptions: [],
        employeeOptions: [],
      },
    };
  },
  watch: {
    'state'(value) {
      if (value) {
        this.department = null
        this.setDepartmentOptions(value)
      }
    },
    'department'(value) {
      if (value) {
        this.form.employees = []
        this.setEmployeeOptions(value)
      }
    },
  },
  methods: {
    openModal() {
      this.showModal = true
      this.$emitter.emit('body-unscrollable')
    },
    closeModal() {
      this.showModal = false
      this.$emitter.emit('body-scrollable')
    },
    initStateOptions() {
      stateApi.getStates().then((res) => {
        this.helper.stateOptions = res.map(stateItem => ({
          value: stateItem.id,
          label: this.$lang.$translate({ru: stateItem.nameRu, kg: stateItem.nameKg}),
        }))
      })
    },
    setDepartmentOptions(value) {
      departmentApi.getActiveDepartmentsByStateId(value).then((res) => {
        this.helper.departmentOptions = res.map(departmentItem => ({
          value: departmentItem.id,
          label: this.$lang.$translate({ru: departmentItem.nameRu, kg: departmentItem.nameKg}),
        }))
      })
    },
    setEmployeeOptions(value) {
      employeeApi.getEmployeesByDepartmentId(value).then((res) => {
        this.helper.employeeOptions = res.data?.map((item) => ({
          id: item.id,
          name: item.fullName,
          position: this.$lang.$translate({ru: item.position.nameRu, kg: item.position.nameKg}),
          type: executorTypes.getValueByKey('EXECUTOR'),
          vacation: item.activeVacation,
        }));
      });
    },
    submit(values, actions) {
      this.submitting = true
      resolutionApi.addExecutors(this.resolution.id, {
        userEmployments: this.form.employees.map(e => ({
          employment: e.id,
          type: executorTypes.getValueByKey('EXECUTOR')
        }))
      })
          .then(() => {
            this.closeModal()
            this.$emitter.emit('refresh-resolution', {reload: false})
            this.$emitter.emit('refresh-resolutions', {reload: false})
            this.$snotify.success(this.$lang.app.SUCCESS_ACTION)
          })
          .catch(error => {
            if (error.response.status === 422) {
              actions.setErrors(error.response.data.errors);
            } else {
              this.$snotify.error(error)
            }
          }).finally(() => {
        this.submitting = false
      })
    },
  },
  beforeMount() {
    this.$emitter.on('open-add-executors-modal', () => {
      if(this.userResolutionRole === 'ROLE_HEAD_OF_DEPARTMENT') {
        this.setEmployeeOptions(this.$store.getters.getCurrentUser.employment.position.department.id)
      } else {
        this.initStateOptions()
      }
      this.openModal()
    })
  },
  beforeUnmount() {
    this.$emitter.off('open-add-executors-modal')
  }
}
</script>
